import { useAuth } from "../hooks/useAuth";
import { useNativeApp } from "../hooks/useNativeApp";
import { useNavigation } from "../hooks/useNavigation";
import { useRealtime } from "../hooks/useRealtime";
import { useSW } from "../hooks/useSW";
import { useUI } from "../hooks/useUI";
import { useUpdateStreakOnAppOpen } from "../hooks/useUpdateStreakOnAppOpen";
import { useManageUserTimezone } from "../hooks/useManageUserTimezone";

export function AppBootstrapHandler() {
  useAuth();
  useNavigation();
  useNativeApp();
  useRealtime();
  useUI();
  useSW();
  useUpdateStreakOnAppOpen();
  useManageUserTimezone();

  return null;
}
